export { CulturalObjectsPage } from "./cultural-objects-page";
